import _toConsumableArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { Redirect, Route, Switch } from '@jupiter/plugin-runtime/router';
import PlatformRelativePaths from '@/router-config/paths';
import routesConfig, { personalizationSettingsRouteConfig } from '@/router-config';
import useGetPersonalizationSettingsEntryShow from '@/hooks/use-get-personalization-settings-entry-show';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Routes = function Routes(_ref) {
  var routesConfig = _ref.routesConfig;
  return /*#__PURE__*/_jsxs(Switch, {
    children: [routesConfig.map(function (_ref2) {
      var path = _ref2.path,
        component = _ref2.component;
      return /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: path,
        component: component
      }, path);
    }), /*#__PURE__*/_jsx(Redirect, {
      from: "/account",
      to: PlatformRelativePaths.SHOP_INFO
    }), /*#__PURE__*/_jsx(Redirect, {
      to: PlatformRelativePaths.HOMEPAGE
    })]
  });
};
var CheckPermissionRoutes = function CheckPermissionRoutes() {
  var isPersonalizationSettingsEntryShow = useGetPersonalizationSettingsEntryShow();
  var setteldRoutesConfig = React.useMemo(function () {
    var retConfig = _toConsumableArray(routesConfig);
    if (isPersonalizationSettingsEntryShow) {
      retConfig.push(personalizationSettingsRouteConfig);
    }
    return retConfig;
  }, [isPersonalizationSettingsEntryShow]);
  return /*#__PURE__*/_jsx(Routes, {
    routesConfig: setteldRoutesConfig
  });
};
export default CheckPermissionRoutes;